import React from "react";
import { Box, ButtonBase } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import { RiMoonLine, RiSunLine } from "@remixicon/react";
import { focusRing, tokens } from "../../utils/figmaTokens";

const MODES = [
  { value: "light", label: "Light", Icon: RiSunLine },
  { value: "dark", label: "Dark", Icon: RiMoonLine },
];

// Admin · Theme Switch (10594:81; 047 D107): the sidebar's Light | Dark control. The half in
// use is raised (P127). MUI keeps the choice in this browser and switches every page (D106, D109).
const ThemeSwitch = () => {
  const { mode, setMode } = useColorScheme();
  const current = mode === "dark" ? "dark" : "light";
  return (
    <Box role="group" aria-label="Theme" sx={{ display: "flex", p: "4px", borderRadius: "10px", bgcolor: tokens.surface.muted }}>
      {MODES.map(({ value, label, Icon }) => {
        const on = value === current;
        return (
          <ButtonBase
            key={value}
            aria-pressed={on}
            onClick={() => setMode(value)}
            sx={{
              flex: 1,
              minWidth: 0,
              gap: "7px",
              px: "10px",
              py: "8px",
              borderRadius: "8px",
              typography: "bodySmallStrong",
              color: on ? tokens.text.primary : tokens.text.tertiary,
              bgcolor: on ? tokens.surface.default : "transparent",
              boxShadow: on ? tokens.shadow.raised : "none",
              ...focusRing,
            }}
          >
            <Icon size={15} aria-hidden />
            {label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default ThemeSwitch;
